import type { ReactNode } from 'react';

interface RowActionGroupProps {
  children: ReactNode;
}

export function RowActionGroup({ children }: RowActionGroupProps) {
  return <div className="flex items-center gap-2">{children}</div>;
}
